export class TokenDecodeHelper {
    static getAvailableProviders(tokenInfo, decodeCallback) {
        let availableProvidersCollection = [];

        if (typeof tokenInfo !== 'undefined') {
            var json = JSON.parse(tokenInfo);
            tokenInfo = Object.assign({}, json);
        }

        if (tokenInfo.id_token) {
            let idToken = decodeCallback(tokenInfo.id_token);

            if (idToken.providers) {
                availableProvidersCollection = idToken.providers.split(';');
            }
        }

        return availableProvidersCollection;
    }
}


// WEBPACK FOOTER //
// ./src/components/helpers/TokenDecodeHelper.js